export default __webpack_public_path__ + "static/media/tiivii-guia-mobile-1.7c57f0d5.png";